import React from 'react';
import {getLabel} from "../../utils";

const satellites = [
    {
       title_en: "Bell Satellite TV",
       title_fr: "Télé Satellite Bell",
       SD_en: "512",
       HD_en: "1583",
       SD_fr: "149",
       HD_fr: "1838",
       sat: "",
   },
    {
       title_en: "Bell Fibe TV",
       title_fr: "Télé Fibe Bell",
       SD_en: "512",
       HD_en: "1512",
       SD_fr: "144",
       HD_fr: "1144",
       sat: "",
   },
    {
       title_en: "Bell Alt TV",
       title_fr: "Alt Télé Bell",
       SD_en: "",
       HD_en: "512",
       SD_fr: "",
       HD_fr: "144",
       sat: "",
   },
    {
       title_en: "Bell Aliant Fibe TV",
       title_fr: "Télé Fibe Bell Aliant",
       SD_en: "63",
       HD_en: "384",
       SD_fr: "808",
       HD_fr: "908",
       sat: "",
   },
    {
       title_en: "Shaw Direct",
       title_fr: "Shaw Direct",
       SD_en: "",
       HD_en: "",
       SD_fr: "",
       HD_fr: "",
       sat: "254",
   }
]

const channelEnglish = (satellite) => {
    return (
        <div> 
            <dl className="channel-en" tabIndex="0">
            {satellite.SD_en && 
                <dt className="inarea-text" tabIndex="0">{getLabel("ENGLISH_SD")}<span className="inarea-channel">{satellite.SD_en}</span></dt>
            }
            {satellite.HD_en && 
                <dt className="inarea-text" tabIndex="0">{getLabel("ENGLISH_HD")}<span className="inarea-channel">{satellite.HD_en}</span></dt>
            }
            {satellite.sat &&
                <dt className="inarea-text" tabIndex="0">Satellite<span className="inarea-channel">{satellite.sat}</span></dt>
            }
            </dl>   
        </div>
    );
}

const channelFrench = (satellite) => {
    return (
        <div>
            <dl className="channel-fr" tabIndex="0">
                {satellite.SD_fr && 
                    <dt className="inarea-text" tabIndex="0">{getLabel("FRENCH_SD")}<span className="inarea-channel">{satellite.SD_fr}</span></dt>
                }
                {satellite.HD_fr &&
                    <dt className="inarea-text" tabIndex="0">{getLabel("FRENCH_SD")}<span className="inarea-channel">{satellite.HD_fr}</span></dt>
                }
            </dl>
        </div>
    );
}

const InYourAreaSat = (props) => {
    return (
        <section className="sat-results" tabIndex="0">
            <p className="channel-heading" tabIndex="0">{getLabel("CHANNEL_PLACEMENT")}</p>
            {satellites.map(satellite => (
            <div tabIndex="0" className="company-item col" key={props.lang === 'en' ? satellite.title_en : satellite.title_fr}>
                <div>
                    <h2 className="company-name" tabIndex="0">{props.lang === 'en' ? satellite.title_en : satellite.title_fr} </h2>
                    {props.lang && props.lang === 'en' ? channelEnglish(satellite) : channelFrench(satellite)}
                    {props.lang && props.lang === 'en' ? channelFrench(satellite) : channelEnglish(satellite)}
                </div>
            </div>
            ))}
        </section>
        
    );
}

export default InYourAreaSat;